import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { useAuth } from '../../hooks/useAuth';
import DataTable from 'react-data-table-component';
import { QRCodeCanvas } from 'qrcode.react';
import { jsPDF } from 'jspdf';
import pdfIcon from '../../assets/images/pdf-icon-dark.png';
import decryptData from '../../helpers/Decryption';

const StationDetail = (props) => {
    const { getToken } = useAuth();
    const [data, setData] = useState();
    const [schedules, setSchedules] = useState();
    const [qrCodeString, setQrCodeString] = useState('');
    const { state } = useLocation();
    useEffect(() => {
        console.log({ state });
        if (state && state.station_id) {
            getStationDetail(state?.station_id);
        }
    }, []);
    const dowloadQRCode = () => {
        // Generate download with use canvas and stream
        const canvas = document.getElementById('qr-code-canvas');
        const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
        const doc = new jsPDF();

        doc.text(`QR code for ${data.name}`, 60, 50);
        doc.addImage(pngUrl, 60, 55);
        doc.save(`${data.name}.pdf`);
    };
    const getStationDetail = async (id = '') => {
        const token = getToken();
        if (token && id) {
            new WebApiCalls()
                .stationDetials(token, id)
                .then(async (res) => {
                    if (res?.code === 200) {
                        const data = await decryptData(res.data);
                        setData(data.station);
                        setSchedules(data?.station?.schedules);
                        const { id, name, lat, long, route } = data?.station;
                        const qrCodeFields = {
                            station: id,
                            name,
                            lat,
                            long,
                            route: route?._id,
                            transitType: route?.transit_type
                        };
                        setQrCodeString(() => JSON.stringify(qrCodeFields));
                    }
                })
                .catch((err) => {
                    console.log('ERROR While Getting station detials ', err);
                });
        }
    };
    const customStyles = {
        rows: {
            style: {
                // minHeight: '72px' // override the row height
                textAlign: 'center'
            }
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                textAlign: 'center',
                backgroundColor: '#13aa61',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        },
        cells: {
            style: {
                borderLeft: '1px solid #eeeeee',
                borderRight: '1px solid #eeeeee',
                borderBottom: '1px solid #eeeeee'
            }
        }
    };

    const scheduleColumns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Arrival Time</span>
                </h6>
            ),
            //{data?.schedules?.arrival ? moment(data?.schedules?.arrival, ['HH:mm']).format('hh:mm a') : ''}
            selector: (row) => moment(row?.arrival, ['HH:mm']).format('hh:mm A'),
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Departure Time</span>
                </h6>
            ),
            selector: (row) => moment(row?.departure, ['HH:mm']).format('hh:mm A'),
            center: true
        }
    ];

    return (
        <>
            <Row className="justify-content-end align-items-center">
                <Col sm={4} md={3} className="text-center">
                    <Link to={state.redirect_url} state={{ route_id: state.route_id || '' }}>
                        <Button className="theme-cancel-btn px-5 py-2">Close</Button>
                    </Link>
                </Col>
            </Row>
            {/* <Row>
                <Col sm={4}>
                    <div className="detail-heading ms-5">Station Details</div>
                </Col>
            </Row> */}
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="p-4 m-3 ps-0 ms-0">
                    <Row>
                        <Col md={3}>
                            <div className="detail-small-heading">Name</div>
                            <div className="detail-value">{data?.name}</div>
                        </Col>

                        <Col md={3}>
                            <div className="detail-small-headingg">Latitude</div>
                            <div className="detail-value">{data?.lat}</div>
                        </Col>

                        <Col md={3}>
                            <div className="detail-small-heading">Longitude</div>
                            <div className="detail-value">{data?.long}</div>
                        </Col>
                        <Col md={3}>
                            <div className="detail-small-heading">Status</div>
                            <div className="detail-value">{data?.status}</div>
                        </Col>
                    </Row>

                    <Row className="mt-5">
                        <Col md={8}>
                            <DataTable
                                columns={scheduleColumns}
                                data={schedules}
                                progressPending={schedules && schedules?.length >= 0 ? false : true}
                                responsive
                                direction="auto"
                                fixedHeaderScrollHeight="300px"
                                subHeaderAlign="center"
                                subHeaderWrap
                                customStyles={customStyles}
                                // defaultSortFieldId={1}
                            />
                        </Col>
                        <Col md={4}>
                            <div className="qr-container">
                                <div className="qr-content">
                                    <QRCodeCanvas id="qr-code-canvas" value={qrCodeString} size={200} className="text-center" />
                                    <button className="btn-pdf-download" onClick={dowloadQRCode}>
                                        Download PDF <img src={pdfIcon} alt="pdf-icon" />
                                    </button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default StationDetail;
